import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" {...props}><path fill="currentColor" d="M7.75 7.75a.97.97 0 011.38 0l15.12 15.12a.97.97 0 11-1.38 1.38L7.75 9.13a.97.97 0 010-1.38z" /><path fill="currentColor" d="M24.25 7.75c.38.38.38 1 0 1.38L9.13 24.25a.97.97 0 01-1.38-1.38L22.87 7.75a.97.97 0 011.38 0z" /></svg>);